'use client'

import Button from '@dustin-web/microsite-components/src/button'
import { useUserSettings } from '@dustin-web/microsite-components/src/hooks'
import { useI18n } from '@dustin-web/microsite-components/src/i18n'

type Props = {
  priceVat: number | null | undefined
}
export const VatSwitcherButton = ({ priceVat }: Props) => {
  const { incExVatTranslation } = useI18n()
  const { setShowPricesInclVat, showPricesInclVat } = useUserSettings()
  return (
    <Button
      defaultBtn
      onClick={() => setShowPricesInclVat(!showPricesInclVat)}
      className="button-stripped u-mb-0 button-stripped"
      text={incExVatTranslation(priceVat)}
    />
  )
}
